import { StyleSheet } from 'react-native';
import { TextSmallSize } from '../../../../common/constants/Fonts';

export const DriverScreeningModalStyle = StyleSheet.create({
  modalBody: {
    fontSize: TextSmallSize,
    color: '#444',
    lineHeight: 20,
  },
  modalClose: {
    marginTop: 16,
    alignSelf: 'flex-end',
    color: '#2e96e1',
    fontWeight: '700',
  },
  scrollContent: {
    gap: 16,
    paddingBottom: 12,
  },
  section: {
    backgroundColor: '#fff',
    borderColor: '#ccc',
    borderWidth: 1,
    borderRadius: 5,
    padding: 12,
    gap: 12,
    marginVertical: 8,
  },
  sectionTitle: {
    fontWeight: '700',
    color: '#1f2937',
  },
  rowGap: {
    flexDirection: 'row',
    gap: 12,
  },
  inputGroup: {
    flex: 1,
    marginHorizontal: 8,
  },
  label: {
    fontSize: TextSmallSize,
    color: '#555',
    marginBottom: 4,
  },
  input: {
    borderWidth: 1,
    borderColor: 'gray',
    borderRadius: 0,
    padding: 10,
    paddingHorizontal: 8,
    backgroundColor: '#fff',
    minHeight: 36,
    marginTop: 4,
    marginBottom: 10,
  },
  pickerWrapper: {
    borderWidth: 1,
    borderColor: 'gray',
    borderRadius: 0,
    backgroundColor: '#fff',
    height: 40,
    justifyContent: 'center',
    paddingHorizontal: 8,
    marginTop: 4,
    marginBottom: 10,
  },
  picker: {
    height: 40,
  },
  pickerOption: {
    fontSize: 20,
  },
  optionDescription: {
    fontSize: TextSmallSize,
    color: '#666',
    marginTop: 4,
  },
  multiline: {
    minHeight: 60,
    textAlignVertical: 'top',
  },
  card: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    padding: 12,
    backgroundColor: '#fff',
    gap: 8,
    marginTop: 12,
  },
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardTitle: {
    fontWeight: '700',
    color: '#374151',
  },
  switchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  switchLabel: {
    fontSize: TextSmallSize,
    color: '#374151',
  },
  footerActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
  },
  ghostButton: {
    paddingVertical: 10,
    paddingHorizontal: 14,
  },
  ghostButtonText: {
    color: '#6b7280',
    fontWeight: '600',
  },
  footerButtons: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  saveButton: {
    backgroundColor: '#2e96e1',
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 6,
  },
  saveButtonText: {
    color: '#fff',
    fontWeight: '700',
  },
  removeButton: {
    marginLeft: 8,
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 6,
    backgroundColor: '#fef2f2',
    borderWidth: 1,
    borderColor: '#fecaca',
  },
  removeButtonText: {
    color: '#b91c1c',
    fontWeight: '600',
  },
  addButton: {
    marginTop: 8,
    alignSelf: 'flex-start',
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 6,
    backgroundColor: '#ecfdf3',
    borderWidth: 1,
    borderColor: '#bbf7d0',
  },
  addButtonText: {
    color: '#15803d',
    fontWeight: '700',
  },
});
